export const premiumOptions = [
  { label: "Basic", value: false },
  { label: "Uncensored", value: true },
];